module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "rating"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.edicaoCalculo),
      expression: "!edicaoCalculo"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.calculando),
      expression: "calculando"
    }],
    staticClass: "overlay",
    staticStyle: {
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('g-button-moema', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.calculando),
      expression: "!calculando"
    }],
    attrs: {
      "color": "primary",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.edicaoCalculo = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Editar")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('table', {
    staticClass: "table table-condensed ratingCalculos"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Representa a situação da entidade e de seus dirigentes com relação a prestação de contas e ao cumprimento de seus compromisssos</h5>'
    }
  }, [_vm._v("CD")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Reflete de maneira indireta as condições economico-financeiras da entidade</h5>'
    }
  }, [_vm._v("RFP")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Sinaliza a capacidade de articulação da entidade considerando que quanto maior o investimento da FBB maior interesse , disposição e compentência em apresentar propostas</h5>'
    }
  }, [_vm._v("IS")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Evidencia o aspecto social da atuação da entidade por meio da quantidade de participantes diretos atendidos</h5>'
    }
  }, [_vm._v("PD")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Reflete a experiência da entidade com base em seu tempo de constituição</h5>'
    }
  }, [_vm._v("HIS 1")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Experiência em projetos e o modus operandi da Fundação</h5>'
    }
  }, [_vm._v("HIS 2")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Reflete as ocorrências vigentes da entidade</h5>'
    }
  }, [_vm._v("OC 1")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Ocorrências registradas para projetos em execução</h5>'
    }
  }, [_vm._v("OC 2")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Ocorrências registradas para projetos encerrado</h5>'
    }
  }, [_vm._v("OC 3")])])]), _vm._v(" "), _c('tr', {
    staticClass: "dado"
  }, [_c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.CD))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.RFP))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.IS))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.PD))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.HIS1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.HIS2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.OC1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.OC2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.OC3))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.rating.ratingCalculado.formula) + " = "), _c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.rating.ratingCalculado.total))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 ratingCalculos"
  }, [(!_vm.calculando) ? _c('span', {
    staticClass: "dado ratingNota"
  }, [_vm._v(_vm._s(_vm.rating.classificacao.nota))]) : _c('span', {
    staticClass: "dado ratingNota"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edicaoCalculo),
      expression: "edicaoCalculo"
    }],
    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('div', [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Convenente:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.dadosGerais.entidade.ds_nome))])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Código:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.dadosGerais.entidade.nr_codigo_forn_erp))])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.dadosGerais.entidade.ds_cnpj)))])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Data de abertura:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.dadosGerais.entidade.dt_data_expedicao_cnpj, "L")))])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Tempo de abertura:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.dadosGerais.entidade.dt_data_expedicao_cnpj, "from", "now")))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Dirigentes:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-bordered text-center"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dadosGerais.entidade.dirigentes), function(dirigente) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(dirigente.ds_nome) + "    "), _c('span', {
      staticStyle: {
        "color": "cornflowerblue"
      }
    }, [_vm._v(_vm._s(dirigente.cargo.ds_descricao))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dirigente.ds_cpf))]), _vm._v(" "), _c('td', [_c('money', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control text-right",
      attrs: {
        "onchange": _vm.totalSerasaDirigentes,
        "name": "serasa_dirigente",
        "type": "text"
      },
      model: {
        value: (dirigente.serasa),
        callback: function($$v) {
          _vm.$set(dirigente, "serasa", $$v)
        },
        expression: "dirigente.serasa"
      }
    })], 1), _vm._v(" "), _c('td', [_c('money', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control text-right",
      attrs: {
        "onchange": _vm.totalSCPCDirigentes,
        "name": "scpc_dirigente",
        "type": "text"
      },
      model: {
        value: (dirigente.scpc),
        callback: function($$v) {
          _vm.$set(dirigente, "scpc", $$v)
        },
        expression: "dirigente.scpc"
      }
    })], 1), _vm._v(" "), _c('td', [(dirigente.cadin !== 0) ? _c('div', {
      staticClass: "data"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (dirigente.cadin),
        expression: "dirigente.cadin"
      }, {
        name: "mask",
        rawName: "v-mask",
        value: ('##/##/####'),
        expression: "'##/##/####'"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required|validdate|dateeqfuture'),
        expression: "'required|validdate|dateeqfuture'"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "onchange": _vm.cadinDirigente,
        "data-vv-as": _vm.cadin_dirigente,
        "masked": _vm.masked
      },
      domProps: {
        "value": (dirigente.cadin)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(dirigente, "cadin", $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.errors.first('cadin_dirigente')) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v(" " + _vm._s(_vm.errors.first('cadin_dirigente')))]) : _vm._e()]) : _c('div', {
      staticClass: "nada_consta dado"
    }, [_vm._v("NADA CONSTA")]), _vm._v(" "), _c('g-button-ujarak', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
      }],
      staticClass: "bt_nada_consta",
      attrs: {
        "color": "warning",
        "size": "button--size-ss",
        "title": '<h5>' + (dirigente.cadin === 0 ? 'Se houver certidão, clique para informar a data de validade' : 'Clique para Nada Consta no Cadin!') + '</h5>'
      },
      nativeOn: {
        "click": function($event) {
          dirigente.cadin = (dirigente.cadin === 0 ? null : 0)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_inicio_mandato, "L")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")))]), _vm._v(" "), _c('td', [_c('i', {
      class: ['fa fa-circle ', dirigente.bt_ativo ? 'text-green' : 'text-red'],
      attrs: {
        "aria-hidden": "true"
      }
    })])])
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-offset-1 col-md-8"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('SERASA da entidade')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "serasa_entidade",
      "type": "text"
    },
    model: {
      value: (_vm.rating.consultas.serasa.entidade),
      callback: function($$v) {
        _vm.$set(_vm.rating.consultas.serasa, "entidade", $$v)
      },
      expression: "rating.consultas.serasa.entidade"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('SERASA da entidade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('SERASA da entidade')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('SERASA de dirigentes')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Dirigentes:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "disabled": true,
      "name": "serasa_dirigentes",
      "type": "text"
    },
    model: {
      value: (_vm.rating.consultas.serasa.dirigentes),
      callback: function($$v) {
        _vm.$set(_vm.rating.consultas.serasa, "dirigentes", $$v)
      },
      expression: "rating.consultas.serasa.dirigentes"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('SERASA de dirigentes')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('SERASA de dirigentes')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('SERASA de dirigentes coobrigação')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Dirigentes Coobrigação:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "serasa_coobrigacao",
      "type": "text"
    },
    model: {
      value: (_vm.rating.consultas.serasa.coobrigacao),
      callback: function($$v) {
        _vm.$set(_vm.rating.consultas.serasa, "coobrigacao", $$v)
      },
      expression: "rating.consultas.serasa.coobrigacao"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('SERASA de dirigentes coobrigação')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('SERASA de dirigentes coobrigação')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Cepim')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-6",
    attrs: {
      "for": "Cepim"
    }
  }, [_vm._v("Cepim:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.rating.consultas.certidoes.Cepim !== 0) ? _c('div', {
    staticClass: "data"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.certidoes.Cepim),
      expression: "rating.consultas.certidoes.Cepim"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate|dateeqfuture'),
      expression: "'required|validdate|dateeqfuture'"
    }],
    ref: "Cepim",
    staticClass: "form-control",
    attrs: {
      "id": "Cepim",
      "type": "text",
      "name": "Cepim",
      "data-vv-as": "Cepim",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.rating.consultas.certidoes.Cepim)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rating.consultas.certidoes, "Cepim", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Cepim')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Cepim')))]) : _vm._e()]) : _c('div', {
    staticClass: "nada_consta dado"
  }, [_vm._v("NADA CONSTA")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia : true, arrow : true, animation : 'perspective', distance:'1', size: 'large', arrow : true}"
    }],
    staticClass: "bt_nada_consta",
    attrs: {
      "color": "warning",
      "size": "button--size-ss",
      "title": '<h5>' + (_vm.rating.consultas.certidoes.Cepim === 0 ? 'Há certidão! Informe a data de validade' : 'Nada Consta !') + '</h5>'
    },
    nativeOn: {
      "click": function($event) {
        _vm.rating.consultas.certidoes.Cepim = (_vm.rating.consultas.certidoes.Cepim === 0 ? null : 0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('CND')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-6",
    attrs: {
      "for": "CND"
    }
  }, [_vm._v("CND ou CPD-EN:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.rating.consultas.certidoes.CND !== 0) ? _c('div', {
    staticClass: "data"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.certidoes.CND),
      expression: "rating.consultas.certidoes.CND"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate|dateeqfuture'),
      expression: "'required|validdate|dateeqfuture'"
    }],
    ref: "CND",
    staticClass: "form-control",
    attrs: {
      "id": "CND",
      "type": "text",
      "name": "CND",
      "data-vv-as": "CND",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.rating.consultas.certidoes.CND)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rating.consultas.certidoes, "CND", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('CND')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CND')))]) : _vm._e()]) : _c('div', {
    staticClass: "nada_consta dado"
  }, [_vm._v("NADA CONSTA")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia : true, arrow : true, animation : 'perspective', distance:'1', size: 'large', arrow : true}"
    }],
    staticClass: "bt_nada_consta",
    attrs: {
      "color": "warning",
      "size": "button--size-ss",
      "title": '<h5>' + (_vm.rating.consultas.certidoes.CND === 0 ? 'Há certidão! Informe a data de validade' : 'Nada Consta !') + '</h5>'
    },
    nativeOn: {
      "click": function($event) {
        _vm.rating.consultas.certidoes.CND = (_vm.rating.consultas.certidoes.CND === 0 ? null : 0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('CRF')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-6",
    attrs: {
      "for": "CRF"
    }
  }, [_vm._v("CRF:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.rating.consultas.certidoes.CRF !== 0) ? _c('div', {
    staticClass: "data"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.certidoes.CRF),
      expression: "rating.consultas.certidoes.CRF"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate|dateeqfuture'),
      expression: "'required|validdate|dateeqfuture'"
    }],
    ref: "CRF",
    staticClass: "form-control",
    attrs: {
      "id": "CRF",
      "type": "text",
      "name": "CRF",
      "data-vv-as": "CRF",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.rating.consultas.certidoes.CRF)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rating.consultas.certidoes, "CRF", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('CRF')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CRF')))]) : _vm._e()]) : _c('div', {
    staticClass: "nada_consta dado"
  }, [_vm._v("NADA CONSTA")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia : true, arrow : true, animation : 'perspective', distance:'1', size: 'large', arrow : true}"
    }],
    staticClass: "bt_nada_consta",
    attrs: {
      "color": "warning",
      "size": "button--size-ss",
      "title": '<h5>' + (_vm.rating.consultas.certidoes.CRF === 0 ? 'Há certidão! Informe a data de validade' : 'Nada Consta !') + '</h5>'
    },
    nativeOn: {
      "click": function($event) {
        _vm.rating.consultas.certidoes.CRF = (_vm.rating.consultas.certidoes.CRF === 0 ? null : 0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('CNDT')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-6",
    attrs: {
      "for": "CNDT"
    }
  }, [_vm._v("CNDT:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.rating.consultas.certidoes.CNDT !== 0) ? _c('div', {
    staticClass: "data"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.certidoes.CNDT),
      expression: "rating.consultas.certidoes.CNDT"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate|dateeqfuture'),
      expression: "'required|validdate|dateeqfuture'"
    }],
    ref: "CNDT",
    staticClass: "form-control",
    attrs: {
      "id": "CNDT",
      "type": "text",
      "name": "CNDT",
      "data-vv-as": "CNDT",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.rating.consultas.certidoes.CNDT)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rating.consultas.certidoes, "CNDT", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('CNDT')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CNDT')))]) : _vm._e()]) : _c('div', {
    staticClass: "nada_consta dado"
  }, [_vm._v("NADA CONSTA")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia : true, arrow : true, animation : 'perspective', distance:'1', size: 'large', arrow : true}"
    }],
    staticClass: "bt_nada_consta",
    attrs: {
      "color": "warning",
      "size": "button--size-ss",
      "title": '<h5>' + (_vm.rating.consultas.certidoes.CNDT === 0 ? 'Há certidão! Informe a data de validade' : 'Nada Consta !') + '</h5>'
    },
    nativeOn: {
      "click": function($event) {
        _vm.rating.consultas.certidoes.CNDT = (_vm.rating.consultas.certidoes.CNDT === 0 ? null : 0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-offset-1 col-md-8"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('SCPC da entidade')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "scpc_entidade",
      "type": "text"
    },
    model: {
      value: (_vm.rating.consultas.scpc.entidade),
      callback: function($$v) {
        _vm.$set(_vm.rating.consultas.scpc, "entidade", $$v)
      },
      expression: "rating.consultas.scpc.entidade"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('SCPC da entidade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('SCPC da entidade')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('SCPC de dirigentes')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Dirigentes:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "disabled": true,
      "name": "scpc_dirigentes",
      "type": "text"
    },
    model: {
      value: (_vm.rating.consultas.scpc.dirigentes),
      callback: function($$v) {
        _vm.$set(_vm.rating.consultas.scpc, "dirigentes", $$v)
      },
      expression: "rating.consultas.scpc.dirigentes"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('SCPC de dirigentes')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('SCPC de dirigentes')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('SCPC de dirigentes coobrigação')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Dirigentes Coobrigação:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "scpc_coobrigacao",
      "type": "text"
    },
    model: {
      value: (_vm.rating.consultas.scpc.coobrigacao),
      callback: function($$v) {
        _vm.$set(_vm.rating.consultas.scpc, "coobrigacao", $$v)
      },
      expression: "rating.consultas.scpc.coobrigacao"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('SCPC de dirigentes coobrigação')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('SCPC de dirigentes coobrigação')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('CADIN da entidade')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-6",
    attrs: {
      "for": "cadin_entidade"
    }
  }, [_vm._v("Entidade:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.rating.consultas.cadin.entidade !== 0) ? _c('div', {
    staticClass: "data"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.cadin.entidade),
      expression: "rating.consultas.cadin.entidade"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate|dateeqfuture'),
      expression: "'required|validdate|dateeqfuture'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cadin_entidade",
      "type": "text",
      "name": "cadin_entidade",
      "data-vv-as": "cadin_entidade",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.rating.consultas.cadin.entidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rating.consultas.cadin, "entidade", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('CADIN da entidade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CADIN da entidade')))]) : _vm._e()]) : _c('div', {
    staticClass: "nada_consta dado"
  }, [_vm._v("NADA CONSTA")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia : true, arrow : true, animation : 'perspective', distance:'1', size: 'large', arrow : true}"
    }],
    staticClass: "bt_nada_consta",
    attrs: {
      "color": "warning",
      "size": "button--size-ss",
      "title": '<h5>' + (_vm.rating.consultas.cadin.entidade === 0 ? 'Há certidão! Informe a data de validade' : 'Nada Consta !') + '</h5>'
    },
    nativeOn: {
      "click": function($event) {
        _vm.rating.consultas.cadin.entidade = (_vm.rating.consultas.cadin.entidade === 0 ? null : 0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('CADIN de dirigentes')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Dirigentes:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.rating.consultas.cadin.dirigentes !== 0) ? _c('div', {
    staticClass: "nada_consta dado"
  }, [_vm._v("CONSTA")]) : _c('div', {
    staticClass: "nada_consta dado"
  }, [_vm._v("NADA CONSTA")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('CADIN de dirigentes coobrigação')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-6",
    attrs: {
      "for": "cadin_dirigentes_coobrigacao"
    }
  }, [_vm._v("Dirigentes Coobrigação:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.rating.consultas.cadin.coobrigacao !== 0) ? _c('div', {
    staticClass: "data"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.cadin.coobrigacao),
      expression: "rating.consultas.cadin.coobrigacao"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validdate|dateeqfuture'),
      expression: "'required|validdate|dateeqfuture'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cadin_dirigentes_coobrigacao",
      "type": "text",
      "name": "cadin_dirigentes_coobrigacao",
      "data-vv-as": "cadin_dirigentes_coobrigacao",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.rating.consultas.cadin.coobrigacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rating.consultas.cadin, "coobrigacao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('CADIN de dirigentes coobrigação')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('CADIN de dirigentes coobrigação')))]) : _vm._e()]) : _c('div', {
    staticClass: "nada_consta dado"
  }, [_vm._v("NADA CONSTA")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia : true, arrow : true, animation : 'perspective', distance:'1', size: 'large', arrow : true}"
    }],
    staticClass: "bt_nada_consta",
    attrs: {
      "color": "warning",
      "size": "button--size-ss",
      "title": '<h5>' + (_vm.rating.consultas.cadin.coobrigacao === 0 ? 'Há certidão! Informe a data de validade' : 'Nada Consta !') + '</h5>'
    },
    nativeOn: {
      "click": function($event) {
        _vm.rating.consultas.cadin.coobrigacao = (_vm.rating.consultas.cadin.coobrigacao === 0 ? null : 0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-offset-1 col-md-8"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Total Geral:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('money', {
    staticClass: "form-control text-right",
    attrs: {
      "name": "total_scpc_serasa",
      "type": "text",
      "disabled": true
    },
    model: {
      value: (_vm.rating.consultas.totalGeral),
      callback: function($$v) {
        _vm.$set(_vm.rating.consultas, "totalGeral", $$v)
      },
      expression: "rating.consultas.totalGeral"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-6",
    attrs: {
      "for": "pep"
    }
  }, [_vm._v("Quantidade de Pessoas Politicamente Expostas (PEP):")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rating.consultas.PEP),
      expression: "rating.consultas.PEP"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "pep",
      "type": "text",
      "name": "pep"
    },
    domProps: {
      "value": (_vm.rating.consultas.PEP)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rating.consultas, "PEP", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n          As restrições que apresentam SCPC e SERASA para a mesma ocorrência são consideradas somente uma única vez no cálculo\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Investimento Social (ISD, últimos 3 anos):")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado",
    attrs: {
      "title": '<h5>Refere-se a soma dos valores contratados e suplementados no projeto</h5>'
    }
  }, [_vm._v("\n              " + _vm._s(_vm._f("real")(_vm.rating.experiencia.investimentoAte3Anos)) + "\n            ")])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Participantes Diretos (ISD, últimos 3 anos):")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado",
    attrs: {
      "title": '<h5>Refere-se a quantidade total de participantes dos projetos contratados</h5>'
    }
  }, [_vm._v("\n              " + _vm._s(_vm.rating.experiencia.participantesAte3Anos) + "\n            ")])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Nº Projetos com a FBB:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado",
    attrs: {
      "title": '<h5>É a quantidade de projetos contratados dessa entidade</h5>'
    }
  }, [_vm._v("\n              " + _vm._s(_vm.rating.experiencia.qtdeProjeto) + "\n            ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-md-offset-1 col-md-8"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(10), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Ocorr. Peso 2:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm._.isNull(_vm.rating.ocorrencias.entidade.tipo2)) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado atualizavel",
    attrs: {
      "title": '<h5>Atualizar consulta</h5>'
    },
    on: {
      "click": function($event) {
        _vm.entidadeOcorrenciaTipo2,
        _vm.calcularRating
      }
    }
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.entidade.tipo2.length))])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Ocorr. Peso 3:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm._.isNull(_vm.rating.ocorrencias.entidade.tipo3)) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado atualizavel",
    attrs: {
      "title": '<h5>Atualizar consulta</h5>'
    },
    on: {
      "click": function($event) {
        _vm.entidadeOcorrenciaTipo3,
        _vm.calcularRating
      }
    }
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.entidade.tipo3.length))])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Ocorr. Peso 4:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm._.isNull(_vm.rating.ocorrencias.entidade.tipo4)) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado atualizavel",
    attrs: {
      "title": '<h5>Atualizar consulta</h5>'
    },
    on: {
      "click": function($event) {
        _vm.entidadeOcorrenciaTipo4,
        _vm.calcularRating
      }
    }
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.entidade.tipo4.length))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(11), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Qtd Executando:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.qtde))])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Ocorr. Peso 2:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosExecutando.tipo2)) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado atualizavel",
    attrs: {
      "title": '<h5>Atualizar consulta</h5>'
    },
    on: {
      "click": function($event) {
        _vm.projetosExecutandoOcorrenciaTipo2,
        _vm.calcularRating
      }
    }
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.tipo2.length))])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Ocorr. Peso 3:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosExecutando.tipo3)) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado atualizavel",
    attrs: {
      "title": '<h5>Atualizar consulta</h5>'
    },
    on: {
      "click": function($event) {
        _vm.projetosExecutandoOcorrenciaTipo3,
        _vm.calcularRating
      }
    }
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.tipo3.length))])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Ocorr. Peso 4:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosExecutando.tipo4)) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado atualizavel",
    attrs: {
      "title": '<h5>Atualizar consulta</h5>'
    },
    on: {
      "click": function($event) {
        _vm.projetosExecutandoOcorrenciaTipo4,
        _vm.calcularRating
      }
    }
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.tipo4.length))])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Qtd Peso 3:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosExecutando.qtdeTipo3))])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("% com Peso 3:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.rating.ocorrencias.projetosExecutando.percTipo3)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._m(12), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Qtd Executado:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosEncerrados.qtde))])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Ocorr. Peso 3:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosEncerrados.tipo3)) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado atualizavel",
    attrs: {
      "title": '<h5>Atualizar consulta</h5>'
    },
    on: {
      "click": function($event) {
        _vm.projetosEncerradosOcorrenciaTipo3,
        _vm.calcularRating
      }
    }
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosEncerrados.tipo3.length))])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Ocorr. Peso 4:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm._.isNull(_vm.rating.ocorrencias.projetosEncerrados.tipo4)) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    staticClass: "dado atualizavel",
    attrs: {
      "title": '<h5>Atualizar consulta</h5>'
    },
    on: {
      "click": function($event) {
        _vm.projetosEncerradosOcorrenciaTipo4,
        _vm.calcularRating
      }
    }
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosEncerrados.tipo4.length))])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("Qtd Peso 3:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.rating.ocorrencias.projetosEncerrados.qtdeTipo3))])])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-6"
  }, [_vm._v("% com Peso 3:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm._f("percentage")(_vm.rating.ocorrencias.projetosEncerrados.percTipo3)))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.calcularRating($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Recalcular Rating")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('table', {
    staticClass: "table table-condensed ratingCalculos"
  }, [_c('thead', [_c('tr', [_c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Representa a situação da entidade e de seus dirigentes com relação a prestação de contas e ao cumprimento de seus compromisssos</h5>'
    }
  }, [_vm._v("CD")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Reflete de maneira indireta as condições economico-financeiras da entidade</h5>'
    }
  }, [_vm._v("RFP")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Sinaliza a capacidade de articulação da entidade considerando que quanto maior o investimento da FBB maior interesse , disposição e compentência em apresentar propostas</h5>'
    }
  }, [_vm._v("IS")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Evidencia o aspecto social da atuação da entidade por meio da quantidade de participantes diretos atendidos</h5>'
    }
  }, [_vm._v("PD")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Reflete a experiência da entidade com base em seu tempo de constituição</h5>'
    }
  }, [_vm._v("HIS 1")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Experiência em projetos e o modus operandi da Fundação</h5>'
    }
  }, [_vm._v("HIS 2")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Reflete as ocorrências vigentes da entidade</h5>'
    }
  }, [_vm._v("OC 1")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Ocorrências registradas para projetos em execução</h5>'
    }
  }, [_vm._v("OC 2")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true,arrow:true,animation:'perspective',distance:'1',size:'large',arrow:true}"
    }],
    attrs: {
      "title": '<h5>Ocorrências registradas para projetos encerrado</h5>'
    }
  }, [_vm._v("OC 3")])])]), _vm._v(" "), _c('tr', {
    staticClass: "dado"
  }, [_c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.CD))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.RFP))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.IS))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.PD))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.HIS1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.HIS2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.OC1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.OC2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rating.ratingCalculado.OC3))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v(_vm._s(_vm.rating.ratingCalculado.formula) + " = "), _c('span', {
    staticClass: "dado"
  }, [_vm._v(_vm._s(_vm.rating.ratingCalculado.total))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 ratingCalculos"
  }, [_vm._v("\n          Rating Entidade "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "dado ratingNota"
  }, [_vm._v(_vm._s(_vm.rating.classificacao.nota))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('div', [_c('g-button-ujarak', {
    attrs: {
      "color": "success",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvar($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" OK")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelar($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Rating da Entidade")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_c('b', [_vm._v("Dados da entidade:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("CPF")]), _vm._v(" "), _c('th', {
    staticClass: "requerido"
  }, [_vm._v("SERASA")]), _vm._v(" "), _c('th', {
    staticClass: "requerido"
  }, [_vm._v("SCPC")]), _vm._v(" "), _c('th', {
    staticClass: "requerido"
  }, [_vm._v("CADIN")]), _vm._v(" "), _c('th', [_vm._v("Início do Mandato")]), _vm._v(" "), _c('th', [_vm._v("Vigência do Mandato")]), _vm._v(" "), _c('th', [_vm._v("Ativo")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_c('b', [_vm._v("Consultas cadastrais e regularidade fiscal e previdenciária:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('b', [_vm._v("SERASA:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('b', [_vm._v("CEPIM e Certidões:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('b', [_vm._v("SCPC:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('b', [_vm._v("CADIN:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_c('b', [_vm._v("Experiência com a FBB:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_c('b', [_vm._v("Ocorrências:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('b', [_vm._v("Entidade:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('b', [_vm._v("Projetos em Execução, ETO, SPS:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('b', [_vm._v("Projetos Encerrados (3 anos):")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('b', [_vm._v("Rating:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4865b1f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/rating.vue
// module id = 1938
// module chunks = 1